import { GraphQLFieldConfig, GraphQLNonNull, GraphQLID } from 'graphql'
import {
  normalizeCustomMetadataFields,
  CustomMetadataField
} from '../../../components/custom-metadata/api/use-custom-metadata-fields'
import { Context } from '../shared'
import { CustomMetadataFieldsType } from '../types/custom-metadata-field'

export const customMetadataFields: GraphQLFieldConfig<
  any,
  Context,
  {
    readonly organizationID: string
  }
> = {
  description: 'Get custom metadata fields required by Organization',
  type: new GraphQLNonNull(CustomMetadataFieldsType),
  args: {
    organizationID: {
      description: 'Organization ID',
      type: new GraphQLNonNull(GraphQLID)
    }
  },
  async resolve(
    _source,
    { organizationID },
    context
  ): Promise<{
    readonly fields: CustomMetadataField[]
  }> {
    const { fields } = await context.connector.get(
      `${organizationID}/metadata/fields`
    )
    return { fields: normalizeCustomMetadataFields(fields) }
  }
}
